module.exports = __webpack_public_path__ + "img/GH-kyujin-top-back005.303ff982.webp";